import { modalsActions } from './slice';

export const openViewProjectModal = modalsActions.openViewProjectModal as (
  id: string,
) => void;

export const openViewUserModal = modalsActions.openViewUserModal as (
  userId: string,
) => void;

export const openMsTeamsModal = modalsActions.openMsTeamsModal as () => void;
export const closeMsTeamsModal = modalsActions.closeMsTeamsModal as () => void;
